// Lib
// Types
import type { KpiType } from '@/lib/analytics/kpis/kpi.type';
import { videoViews95PercentConfig } from '@/lib/analytics/kpis/pinterest/videoViews95Percent';

// Components
import { MediaViewerKpiLoader } from '@/components/base/Kpi/KpiLoader';

export const mediaViewerVideoViews95PercentConfig: KpiType<typeof MediaViewerKpiLoader> = {
    ...videoViews95PercentConfig,
    loader: MediaViewerKpiLoader
};
